import { render, staticRenderFns } from "./syspdrtlist.vue?vue&type=template&id=3fd34f62"
import script from "./syspdrtlist.vue?vue&type=script&lang=js"
export * from "./syspdrtlist.vue?vue&type=script&lang=js"
import style0 from "./syspdrtlist.vue?vue&type=style&index=0&id=3fd34f62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports